import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getAltFromSrc from 'commons/getAltFromSrc';
import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';
import useBrokenImageUrls from 'global-state/brokenImageUrls/useBrokenImageUrls';
import useSetBrokenImageUrl from 'global-state/brokenImageUrls/useSetBrokenImageUrl';
import JBImage from 'components/essentials/JBImage';
import Placeholder from 'components/consumer/Placeholder';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import Prefetcher from '../../../../essentials/Prefetcher/index';
import { getMainImageImgixPropsForPhoto, getThumbnailImageImgixPropsForPhoto } from '../helpers/imgix-props';
import usePDPDesktopHeroSizeProps from '../helpers/usePDPDesktopHeroSizeProps';
import { PDP_GALLERY_THUMBNAIL_IMAGE } from '../specs/testIds';
const PDPDesktopHeroThumbnail = t0 => {
  const $ = _c(48);
  const {
    ariaLabel,
    ariaPressed,
    children,
    cropData,
    enableCrops,
    fallbackSrc,
    icon,
    iconCenter: t1,
    loading: t2,
    isSelected: t3,
    onClick: t4,
    onLoadFailure: t5,
    onMouseEnter: t6,
    src,
    title,
    type: t7,
    isConfigFlipped: t8,
    isCylindoPhoto: t9,
    iconClass: t10
  } = t0;
  const iconCenter = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const isSelected = t3 === undefined ? false : t3;
  const onClick = t4 === undefined ? _temp : t4;
  const onLoadFailure = t5 === undefined ? _temp2 : t5;
  const onMouseEnter = t6 === undefined ? _temp3 : t6;
  const type = t7 === undefined ? "studio" : t7;
  const isConfigFlipped = t8 === undefined ? false : t8;
  const isCylindoPhoto = t9 === undefined ? false : t9;
  const iconClass = t10 === undefined ? "" : t10;
  const [isError, setIsError] = useState(false);
  const brokenImageUrls = useBrokenImageUrls();
  const setBrokenImageUrl = useSetBrokenImageUrl();
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  let t11;
  if ($[0] !== brokenImageUrls || $[1] !== isCylindoPhoto || $[2] !== src) {
    t11 = isCylindoPhoto && brokenImageUrls.includes(getImageUrlWithoutQuery(src));
    $[0] = brokenImageUrls;
    $[1] = isCylindoPhoto;
    $[2] = src;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const isCylindoSrcBroken = t11;
  const isCylindoFallbackBroken = !fallbackSrc || brokenImageUrls.includes(getImageUrlWithoutQuery(fallbackSrc));
  const cylindoSrc = isCylindoSrcBroken && fallbackSrc ? fallbackSrc : src;
  if (!(loading || src || children || icon) || isError || isCylindoSrcBroken && isCylindoFallbackBroken) {
    return null;
  }
  const t12 = !isSelected;
  let t13;
  if ($[4] !== isSelected || $[5] !== loading || $[6] !== t12) {
    t13 = classNames("items-stretch border border-solid rounded bg-white flex justify-between h-[38px] overflow-hidden w-11 lg:max-[1100px]:h-[33px] lg:max-[1100px]:w-[39px] [&+&]:ml-1", "hover:cursor-pointer hover:border-brand-dark", "focus-visible:outline-brand", {
      "hover:cursor-default hover:border-gray-light8": loading,
      "border-gray-light7": t12,
      "border-brand-dark": isSelected
    });
    $[4] = isSelected;
    $[5] = loading;
    $[6] = t12;
    $[7] = t13;
  } else {
    t13 = $[7];
  }
  const t14 = (type === "configuration" || type === "cylindo") && isConfigFlipped;
  let t15;
  if ($[8] !== t14) {
    t15 = classNames("relative items-center flex justify-center h-full w-full", {
      "scale-x-[-1]": t14
    });
    $[8] = t14;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  let t16;
  if ($[10] !== cropData || $[11] !== cylindoSrc || $[12] !== enableCrops || $[13] !== fallbackSrc || $[14] !== isCylindoPhoto || $[15] !== isCylindoSrcBroken || $[16] !== mainPhotoSizeProps || $[17] !== onLoadFailure || $[18] !== setBrokenImageUrl || $[19] !== src || $[20] !== type) {
    t16 = !!src && <Prefetcher onRenderAssets={[{
      url: src,
      imgixProps: !isCylindoPhoto ? {
        ...getMainImageImgixPropsForPhoto({
          src,
          type,
          cropData
        }, enableCrops),
        ...mainPhotoSizeProps
      } : null,
      isProductImage: true
    }]} className="block h-full !w-full">{isCylindoPhoto ? <img className="h-full" data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} src={cylindoSrc} width={44} height={38} alt={getAltFromSrc(cylindoSrc)} onError={() => {
        if (!isCylindoSrcBroken) {
          setBrokenImageUrl(src);
          onLoadFailure();
        } else {
          setBrokenImageUrl(fallbackSrc);
        }
      }} /> : <JBImage className={classNames("flex-1", {
        "object-none h-[38px] w-11": type === "configuration" || type === "cylindo",
        "h-full object-cover w-full": type === "studio"
      })} data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} forPage="pdp" lazy={false} onLoad={isFail => {
        if (!isFail) {
          return;
        }
        setIsError(true);
        onLoadFailure();
      }} {...getThumbnailImageImgixPropsForPhoto({
        src,
        type
      })} />}</Prefetcher>;
    $[10] = cropData;
    $[11] = cylindoSrc;
    $[12] = enableCrops;
    $[13] = fallbackSrc;
    $[14] = isCylindoPhoto;
    $[15] = isCylindoSrcBroken;
    $[16] = mainPhotoSizeProps;
    $[17] = onLoadFailure;
    $[18] = setBrokenImageUrl;
    $[19] = src;
    $[20] = type;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== children) {
    t17 = !!children && <div className="text-xs font-bold text-gray">{children}</div>;
    $[22] = children;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== icon || $[25] !== iconCenter || $[26] !== iconClass) {
    t18 = !!icon && <div className={classNames(`items-center flex justify-center [&_svg]:p-[5px] ${iconClass}`, {
      absolute: iconCenter
    })}>{icon}</div>;
    $[24] = icon;
    $[25] = iconCenter;
    $[26] = iconClass;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t18) {
    t19 = <div className={t15}>{t16}{t17}{t18}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== loading || $[34] !== t19) {
    t20 = <Placeholder loading={loading} type="rect" className="!mr-0">{t19}</Placeholder>;
    $[33] = loading;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== ariaPressed || $[37] !== isSelected) {
    t21 = !!isSelected && ariaPressed === undefined && <VisuallyHidden>- selected</VisuallyHidden>;
    $[36] = ariaPressed;
    $[37] = isSelected;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== ariaLabel || $[40] !== ariaPressed || $[41] !== onClick || $[42] !== onMouseEnter || $[43] !== t13 || $[44] !== t20 || $[45] !== t21 || $[46] !== title) {
    t22 = <button aria-label={ariaLabel} aria-pressed={ariaPressed} title={title} className={t13} onClick={onClick} onMouseEnter={onMouseEnter} type="button">{t20}{t21}</button>;
    $[39] = ariaLabel;
    $[40] = ariaPressed;
    $[41] = onClick;
    $[42] = onMouseEnter;
    $[43] = t13;
    $[44] = t20;
    $[45] = t21;
    $[46] = title;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
};
PDPDesktopHeroThumbnail.propTypes = {
  ariaLabel: PropTypes.string,
  ariaPressed: PropTypes.bool,
  children: PropTypes.node,
  cropData: PropTypes.object,
  enableCrops: PropTypes.bool,
  fallbackSrc: PropTypes.string,
  icon: PropTypes.node,
  iconCenter: PropTypes.bool,
  iconClass: PropTypes.string,
  isConfigFlipped: PropTypes.bool,
  isCylindoPhoto: PropTypes.bool,
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onLoadFailure: PropTypes.func,
  onMouseEnter: PropTypes.func,
  src: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'open-close', 'studio'])
};
export default PDPDesktopHeroThumbnail;
function _temp() {}
function _temp2() {}
function _temp3() {}